import { defineRecipe } from "@chakra-ui/react"

export const recipe = defineRecipe({
    base: {
        display: 'flex',
        cursor: 'pointer',
        paddingInline: 'unset',
        paddingBlock: 'unset',
        borderRadius: '.35rem',
    },
    variants: {
        visual: {
            solid: {
                bg: 'secondary.500', color: 'white'
            },
            outline: { borderWidth: '1px', borderColor: 'red.200' },
            icon: {
                p: '.5rem',
                borderRadius: '50%',
                bg: 'white',
                color: 'black',
            },
            primary: {
                bg: 'white',
                color: 'black',
            },
        },
        size: {
            sm: { fontSize: '12px', p: '.5rem' },
            md: { fontSize: '16px', p: '1rem' },
            lg: { fontSize: '24px', p: '1rem' },
        },
    },
    defaultVariants: {
        visual: 'solid',
        size: 'md',
    },
});

export default recipe;
